// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"jH","contentFrame":"jI","buttonGroup":"jJ","button":"jK","header":"jL","text":"jM","contentImage":"jN","closeButton":"jO"};